/* Shared Splide enhancements for the Candela sliders:
   - trackpad horizontal swipe moves the slider
   - cursor: grab while the mouse moves over the slider, pointer once it rests, grabbing while dragging */
(function () {
  var hasHover = window.matchMedia('(hover: hover)').matches;

  window.candelaEnhanceSplide = function (splide) {
    var root = splide.root;
    var track = root.querySelector('.splide__track');
    if (!track) return;

    /* --- Cursor states --- */
    var restTimer = null;

    splide.on('drag', function () {
      root.classList.add('is-grabbing');
    });
    splide.on('dragged', function () {
      root.classList.remove('is-grabbing');
    });

    if (hasHover) {
      /* Switch to the grab hand only after sustained motion (time + distance),
         so a short nudge towards a card keeps the pointer. Rest returns the pointer. */
      var MOVE_MS = 300;
      var MOVE_PX = 40;
      var REST_MS = 250;
      var moveStart = 0;
      var lastX = 0;
      var lastY = 0;
      var dist = 0;

      root.addEventListener('mousemove', function (e) {
        var now = Date.now();
        if (!moveStart) {
          moveStart = now;
          lastX = e.clientX;
          lastY = e.clientY;
          dist = 0;
        } else {
          dist += Math.abs(e.clientX - lastX) + Math.abs(e.clientY - lastY);
          lastX = e.clientX;
          lastY = e.clientY;
        }

        if (!root.classList.contains('is-moving') && now - moveStart >= MOVE_MS && dist >= MOVE_PX) {
          root.classList.add('is-moving');
        }

        window.clearTimeout(restTimer);
        restTimer = window.setTimeout(function () {
          root.classList.remove('is-moving');
          moveStart = 0;
          dist = 0;
        }, REST_MS);
      });

      root.addEventListener('mouseleave', function () {
        window.clearTimeout(restTimer);
        root.classList.remove('is-moving');
        moveStart = 0;
        dist = 0;
      });
    }

    /* --- Trackpad horizontal swipe --- */
    var acc = 0;
    var locked = false;
    var resetTimer = null;

    /* Passive on purpose: Safari blocks all page scroll over an element with a
       non-passive wheel listener while <html> has overscroll-behavior (WebKit 281300),
       even when the listener never cancels. */
    track.addEventListener('wheel', function (e) {
      var dx = Math.abs(e.deltaX);
      if (dx < 3 || dx <= Math.abs(e.deltaY) * 2) return;
      if (locked) return;

      acc += e.deltaX;
      window.clearTimeout(resetTimer);
      resetTimer = window.setTimeout(function () { acc = 0; }, 200);

      if (Math.abs(acc) >= 30) {
        splide.go(acc > 0 ? '>' : '<');
        acc = 0;
        locked = true;
        window.setTimeout(function () { locked = false; }, 450);
      }
    }, { passive: true });
  };
})();
